/* import __COLOCATED_TEMPLATE__ from './detail-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();